<template xmlns:v-swiper="http://www.w3.org/1999/xhtml">
  <div class="sha-info-page">
<!--    <code>{{ offer_modal_status }}</code>-->
    <div class="sha-info-hero">
      <h1>Delivery Area</h1>
      <nav class="sha-info-tabs" aria-label="Information pages">
        <router-link to="/delivery-locations" class="sha-info-tab" exact-active-class="active">Delivery Area</router-link>
        <router-link to="/contact-us" class="sha-info-tab" exact-active-class="active">Contact Us</router-link>
        <router-link to="/policy" class="sha-info-tab" exact-active-class="active">Privacy Policy</router-link>
        <router-link to="/terms-condition" class="sha-info-tab" exact-active-class="active">Terms of Use</router-link>
      </nav>
    </div>
    <div class="container-fluid">
      <div class="col-md-12">
        <div class="row order-process  pdt30">
           <div class="col-md-12 text-center mb30"><h3 class="mb0">Our Delivery Area</h3>
                <img src="@/assets/images/delivery-truck.png" alt="Location" width="45px"/>
              </div>
          <div class="locations">

            <div class="row" v-if="globalLanguage=='EN'">

              <div class="col-md-3 loc" v-for="location in locations" :key="location.location_name"><i class="fa fa-map-marker"></i>
                {{ location.location_name }}
              </div>
            </div>
            <div class="row" v-else>
              <div class="col-md-12 text-center mb30"><h3 class="mb0">আমাদের ডেলিভারি এলাকা</h3>
                <img src="@/assets/images/delivery-truck.png" alt="Location" width="45px"/>
              </div>
              <div class="col-md-3 loc" v-for="location in locations" :key="location.location_name"><i class="fa fa-map-marker"></i>
                {{ location.location_name_bn }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CartData
      :carts="carts"
      :sum-cart-total="sum_cart_total || 0"
      :file-url="fileUrl"
      :global-language="globalLanguage"
      @remove-cart-item="removeCartItem"
      @cart-increment="cartIncrement"
      @cart-decrement="cartDecrement"
    />
    <div class="mobilemenu">
      <div class="same">
        <router-link to="/" class="icon-bottom">
          <img src="@/assets/images/icons/home-ash.png" width="31px">
        </router-link >
      </div>
      <div class="gocheckout" v-if="carts.length>0">
        <router-link to="/checkout">
          GO CHECKOUT
        </router-link>
      </div>
      <div class="gocheckout start" @click="toogleNav()" v-else>
        <span>
          START SHOPPING
        </span>
      </div>
      <div class="mybag same carts">
        <span>
          <span class="badge">0</span>
          <img class="iconbag" src="@/assets/images/icons/bag.png" alt="Shopping-bag" height="31px">
        </span>
      </div>
    </div>
  </div>
</template>
<script>
// import apiScript from "../apiScript";
// api.hello();
const $ = require('jquery');
window.$ = $;

$(function () {
  $(window)
    .scroll(function () {
      $('nav')
        .toggleClass('scrolled', $(this)
          .scrollTop() > 30);
    });
});
import axios from 'axios';
import CartData from "./CartData";
//import api from '../apiScript';

const defaultDeliveryLocations = [
  { location_name: 'Paris (75)', location_name_bn: 'Paris (75)' },
  { location_name: 'les Hauts-de-Seine (92)', location_name_bn: 'les Hauts-de-Seine (92)' },
  { location_name: 'la Seine-Saint-Denis (93)', location_name_bn: 'la Seine-Saint-Denis (93)' },
  { location_name: 'le Val-de-Marne (94)', location_name_bn: 'le Val-de-Marne (94)' },
  { location_name: 'la Seine-et-Marne (77)', location_name_bn: 'la Seine-et-Marne (77)' },
  { location_name: 'les Yvelines (78)', location_name_bn: 'les Yvelines (78)' },
  { location_name: "l'Essonne (91)", location_name_bn: "l'Essonne (91)" },
  { location_name: "le Val-d'Oise (95)", location_name_bn: "le Val-d'Oise (95)" },
];

export default {
  components: { CartData },
  data() {
    return {
      offer_modal_img:'',
      offer_modal_status:'',
      offer_bg:'',
      offer_url:'',
      menuStatus: true,
      token: '',
      products: [],
      getcarts: [],
      modalProductData: [],
      carts: [],
      cartsCountProduct: '',
      loadMore: true,
      isLoading:false,
      isOpen: true,
      sum_cart_total: '',
      quantity: 1,
      phone: '',
      user_id:'',
      images: [],
      locations: defaultDeliveryLocations,
      parseCartData: [],
      changeModalGallery_image: '',
      allCategories: [],
      language: '',
      swiperOption: {
        slidesPerView: 1,
        loop: true,
        speed: 700,
        autoplay: {
          delay: 5500,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        file: '',
      },
    };
  },
  created: function () {
    this.deliveryLocations();
    this.language = this.globalLanguage;
    if(localStorage.getItem("userinfo")){
      this.phone=JSON.parse(localStorage.getItem("userinfo")).phone;
    }
    //localStorage.clear();
  },
  mounted() {
    // this.getImagesInfo()
    let vm = this;
    if (localStorage.getItem("token")) {
      let vm = this;
      vm.token = localStorage.getItem("token");
    }
    if (localStorage.getItem("carts")) {
      vm.carts = JSON.parse(localStorage.getItem("carts"));
    } else {
      vm.carts = [];
    }
    vm.cartsCountProduct = JSON.parse(localStorage.getItem("cartsCountProduct"));
    this.calculateCartTotal();
  },
  methods: {
    toogleNav: function () {
      $(".small-device #sidebar-area")
        .toggleClass('show');
      $("#content-area")
        .toggleClass('fullwidth');
      $("#sidebar-area")
        .toggleClass('hidden-sidebar');
      if (this.menuStatus == true) {
        this.menuStatus = false;
      } else if (this.menuStatus == false) {
        this.menuStatus = true;
      }
    },
    deliveryLocations: function () {
      let vm = this;
      axios.get(this.globalUrl + "all-delivery-locations")
        .then(function (response) {
          //console.log(response.data);
          vm.locations = vm.mergeDeliveryLocations(response.data.locations);
          vm.offer_modal_img = response.data.offer.offer_image;
          vm.offer_modal_status = response.data.offer.status;
          vm.offer_bg = response.data.offer.color;
          vm.offer_url = response.data.offer.url;
        })
        .catch((response) => {
          //console.log(response);
          vm.$toasted.show('Something wrong  Try again.', {
            type: 'error',
            icon: 'fa-exclamation-triangle'
          });
        });
    },
    mergeDeliveryLocations: function (apiLocations) {
      let locations = defaultDeliveryLocations.slice();
      let existingLocationNames = locations.map(function (location) {
        return location.location_name.toLowerCase();
      });

      if (!Array.isArray(apiLocations)) {
        return locations;
      }

      apiLocations.forEach(function (location) {
        if (!location || !location.location_name) {
          return;
        }

        let locationName = location.location_name.toLowerCase();
        if (existingLocationNames.indexOf(locationName) === -1) {
          locations.push(location);
          existingLocationNames.push(locationName);
        }
      });

      return locations;
    },
    increment() {
      this.quantity++;
    },
    decrement() {
      if (this.quantity === 1) {

      } else {
        this.quantity--;
      }
    },
    cartIncrement(product_id) {
      //alert(product_id);
      let objIndex = this.carts.findIndex((obj => obj.product_id == product_id));
      let oldQuantity = this.carts[objIndex].cart_quantity;
      let stock_quantity = this.carts[objIndex].stock_quantity;
      if(oldQuantity<stock_quantity){
        let newQuantity = oldQuantity + 1;
        let price = this.carts[objIndex].price;
        this.carts[objIndex].cart_quantity = newQuantity;
        this.carts[objIndex].subtotal = price * newQuantity;
        localStorage.setItem("carts", JSON.stringify(this.carts));
        this.carts = JSON.parse(localStorage.getItem("carts"));
        $('#'+product_id+ " .amountQuantity").text(newQuantity);
        this.calculateCartTotal();
        $("#"+product_id).addClass("animated");
        setTimeout(function(){
          $("#"+product_id).removeClass("animated");
        }, 500);
      }
    },
    cartDecrement(product_id) {
      let objIndex = this.carts.findIndex((obj => obj.product_id == product_id));
      let oldQuantity = this.carts[objIndex].cart_quantity;
      if (oldQuantity > 1) {
        let newQuantity = oldQuantity - 1;
        let price = this.carts[objIndex].price;
        this.carts[objIndex].cart_quantity = newQuantity;
        this.carts[objIndex].subtotal = price * newQuantity;
        localStorage.setItem("carts", JSON.stringify(this.carts));
        this.carts = JSON.parse(localStorage.getItem("carts"));
        this.calculateCartTotal();
      }
      $("#" + product_id)
        .addClass("animated");
      setTimeout(function () {
        $("#" + product_id)
          .removeClass("animated");
      }, 500);
    },
    removeCartItem: function (product_id) {
      //alert(product_id);
      this.carts = this.carts.filter((e) => e.product_id !== product_id);
      localStorage.setItem("carts", JSON.stringify(this.carts));
      this.calculateCartTotal();
    },
    calculateCartTotal() {
      let vm = this;
      for (var i = 0, sum = 0; i < vm.carts.length; sum += vm.carts[i++].subtotal) ;
      vm.sum_cart_total = sum;
      //calculate total  product  amount
      for (var i = 0, totalSum = 0; i < vm.carts.length; totalSum += vm.carts[i++].cart_quantity) ;
      vm.cartsCountProduct = totalSum;
      localStorage.setItem("cartsCountProduct", totalSum);
      $(".carts .badge")
        .text(vm.carts.length);
    }
  }
};
</script>
